import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M20 16c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-1c0-1.1.9-2 2-2zm-1.34-4.49c1.43 0 1.68.48 2.65.83.41.15.69.53.69.96 0 .71-.72 1.22-1.39.96-.76-.3-1.12-.76-1.93-.76-1.24 0-1.38 1-3.33 1-1.91 0-2.14-1-3.33-1-1.24 0-1.38 1-3.33 1-1.91 0-2.14-1-3.33-1-.82 0-1.2.49-1.99.78-.66.24-1.36-.25-1.36-.94 0-.42.26-.8.65-.94.72-.26 1.13-.89 2.68-.89 1.91 0 2.14 1 3.33 1 1.24 0 1.38-1 3.33-1 1.91 0 2.14 1 3.33 1 1.24 0 1.38-1 3.33-1zM12 3c5.72 0 10.02 2 10 6 0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1l.0044-.2202C2.1594 4.9266 6.3957 3 12 3z"
  }],
  circles: []
};
var LunchDiningIcon = function LunchDiningIcon(props) {
  return renderIcon(props, iconType);
};
export { LunchDiningIcon };